import { Handle, Position, NodeResizer } from "@xyflow/react";
import React, { useEffect, useRef, useState } from "react";

import { FaFolder } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { updateNode } from "../../utils/flowSlice";

const GroupNode = ({ data, isConnectable }) => {
  const [dimensions, setDimensions] = useState(data.dimensions || { width: 500, height: 500 });
  const [isFocus, setIsFocus] = useState(false);
  const [title, setTitle] = useState(data.title || "");
  const [childNodes, setChildNodes] = useState([]);
  const nodeRef = useRef(null);
  const dispatch = useDispatch();
  const nodes = useSelector((store) => store.flow.nodes);
  const filteredNodes = nodes.filter((node) => node.parentId === data.id);
  if (JSON.stringify(filteredNodes) !== JSON.stringify(childNodes)) {
    setChildNodes(filteredNodes);
  }
  const getScript = () => {
    const newScriptArray = childNodes.map((node) => ({
      id: node.id,
      type: node.type,
      script: node.data.script,
    }));

    dispatch(
      updateNode({
        id: data.id,
        data: {
          ...data,
          title: title,
          scriptArray: newScriptArray,
          dimensions: dimensions
        },
      })
    );
  };

  useEffect(() => {
    getScript();
  }, [childNodes, title, dimensions]);

  const handleResize = (event, params) => {
    setDimensions({ width: params.width, height: params.height });
  };

  return (
    <div
      onClick={() => setIsFocus(!isFocus)}
      ref={nodeRef}
      style={{
        width: dimensions.width,
        height: dimensions.height,
        position: "relative",
      }}
      className="text-updater-node"
    >
      <NodeResizer
        onResize={handleResize}
        color="#F7F9FB"
        isVisible={true} // Hides default corner controls
        minWidth={400}
        minHeight={300}
      />
      <Handle
        type="source"
        position={Position.Right}
        isConnectable={isConnectable}
        style={{
          width: "20px", // Default width
          height: "20px", // Default height
          background: "white", // Default background color
          border: "2px solid #32b5e5", // Default border color
          borderRadius: "50%", // Circular shape
          position: "absolute",
          right: "-20px", // Ensure proper alignment
          top: "50%", // Align vertically
          transform: "translateY(-50%)", // Center the handle
          display: "flex",
          alignItems: "center",
          lineHeight: "20px", // Match the handle's height for vertical centering
          fontSize: "12px", // Ensure text size fits
          justifyContent: "center",
          transition: "transform 0.2s, background-color 0.2s, right 0.2s", // Smooth hover transition
        }}
        onMouseEnter={(e) => {
          e.target.style.transform = "translateY(-50%) scale(1.5)"; // Keep alignment and scale
          e.target.style.background = "#32b5e5"; // Change background to blue
          e.target.style.color = "white"; // Set text color to white
          e.target.innerHTML = "+"; // Add "+" symbol inside
        }}
        onMouseLeave={(e) => {
          e.target.style.transform = "translateY(-50%) scale(1)"; // Reset scale while maintaining alignment
          e.target.style.background = "white"; // Reset background to white
          e.target.style.color = ""; // Clear the text color
          e.target.innerHTML = ""; // Remove "+" symbol
        }}
      />
      <div
        className={`w-full h-full mx-auto rounded-[15px] shadow-md border-[4px]  focus-within:border-gray-500 transition-colors duration-300 flex flex-col ${data.parentReady ? "border-gray-500" : "border-gray-300"
          }`}
        tabIndex="0"
      >
        {/* <!-- Header --> */}
        <div className="flex justify- items-center h-[50px] bg-slate-800 text-white px-4 py-2 rounded-t-[8px] rounded-b-[-12px] space-x-2">
          <span className="text-lg">
            <FaFolder color="white" />
          </span>
          <input
            className="font-semibold text-xl bg-slate-800 focus-within:outline-none w-[600px]"
            placeholder="Type the title..."
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          ></input>
        </div>
      </div>
    </div>
  );
};

export default GroupNode;
